<template>
  <div class="content">
    <title-bar title="Deposit Benefits"></title-bar>
    <div class="content-c">
      <img src="../../../assets/img/activity/banner1.png" width="100%" />
      <div class="content-b">
        <div v-safe-html.rich="activityRuleHtml"></div>
        <div v-if="readError" class="read-error">{{ readError }}</div>
      </div>
      <van-button
        @click="goToRec"
        size="large"
        class="popup-button"
        color="linear-gradient(to right, #076237, #5DEC8A)"
      >
        Recharge
      </van-button>
      <login v-model="showPopup" overlay></login>
    </div>
  </div>
</template>
<script>
import { GetPromoRule } from '@/api/common'
import { isReadableOkResponse, responseFailMessage, safeArray, safeContent, safeObject, safeString } from '@/views/layout/safeLayout'

const ACTIVITY_RULE_LIST_KEYS = ['promoRuleList', 'ruleList', 'activityList', 'list', 'dataList', 'records', 'items']
const ACTIVITY_RULE_ENVELOPE_KEYS = ['content', 'payload', 'extra', 'page', 'data', 'body']
const ACTIVITY_RULE_FIELD_KEYS = ['promoRules', 'promo_rules', 'ruleContent', 'rule_content', 'rules', 'description', 'descr', 'content', 'detail', 'details', 'remark', 'remarks']
const ACTIVITY_RULE_READ_ERROR = '活动规则读取失败，已保留默认文案。'
const ACTIVITY_RULE_MAX_DEPTH = 12
const ACTIVITY_RULE_KEYS = ['deposit benefits', 'total recharge', 'daily recharge', 'recharge bonus', '充值福利', '累计充值']
const EXCLUDED_ACTIVITY_RULE_KEYS = ['first recharge', 'first deposit', '首充', '首次充值']

function collectActivityRules(source, depth = 0, out = [], seen = new Set()) {
  if (!source || typeof source !== 'object' || depth >= ACTIVITY_RULE_MAX_DEPTH || seen.has(source)) return out
  seen.add(source)
  for (const key of ACTIVITY_RULE_LIST_KEYS) {
    safeArray(source[key]).forEach(rule => out.push(rule))
  }
  for (const key of ACTIVITY_RULE_ENVELOPE_KEYS) {
    const value = source[key]
    if (!value || typeof value !== 'object') continue
    collectActivityRules(value, depth + 1, out, seen)
  }
  return out
}

function activityRuleText(rule) {
  const item = safeObject(rule)
  for (const key of ACTIVITY_RULE_FIELD_KEYS) {
    const value = safeString(item[key]).trim()
    if (value) return value
  }
  return ''
}

function matchesActivityRule(rule) {
  const item = safeObject(rule)
  const text = [
    item.activityType,
    item.activity_type,
    item.actTypeKey,
    item.act_type_key,
    item.promoType,
    item.promo_type,
    item.promoDetail,
    item.promo_detail,
    item.type,
    item.code,
    item.ruleCode,
    item.rule_code,
    item.name,
    item.title,
    item.descr,
    item.description
  ].map(safeString).join(' ').toLowerCase()
  if (EXCLUDED_ACTIVITY_RULE_KEYS.some(key => text.includes(key))) return false
  return ACTIVITY_RULE_KEYS.some(key => text.includes(key))
}

export default {
  name: 'ActivityRecharge',
  components: {},
  data() {
    return {
      activityRuleHtml: '<p class="m-t-10 f-t-15 l-h-20">Extra cash rewards for deposits. Higher deposits, higher rewards up to 10%.</p><div class="content-gb"><p style="color: #2196f3">Special Note:</p><p class="m-t-20">Ensure unique account,phone,and card details.</p></div>',
      readError: '',
      showPopup: false
    }
  },
  mounted() {
    this.loadActivityRule()
  },
  methods: {
    async loadActivityRule() {
      try {
        const data = await GetPromoRule()
        if (!isReadableOkResponse(data)) {
          this.readError = responseFailMessage(data, ACTIVITY_RULE_READ_ERROR)
          return
        }
        const rule = collectActivityRules(safeContent(data)).find(matchesActivityRule)
        const ruleHtml = activityRuleText(rule)
        if (ruleHtml) {
          this.activityRuleHtml = ruleHtml
          this.readError = ''
        }
      } catch (error) {
        this.readError = responseFailMessage(error, ACTIVITY_RULE_READ_ERROR)
      }
    },
    requireLogin() {
      this.showPopup = true
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    goToRec() {
      if (!this.token) {
        this.requireLogin()
        return
      }
      this.$jumpTo('/rechargeCont', {}, { replace: true })
    }
  }
}
</script>
<style lang="less" scoped>
.content-c {
  padding: 3%;
}
.popup-button {
  box-shadow: 0 4px 1px rgba(59, 196, 107, 1); /* 阴影效果 */
  border-radius: 15px; /* 圆角 */
  color: @background-color !important; /* 文字颜色 */
  font-weight: bold;
  margin-top: 15px;
}
.content-gb {
  margin-top: 15px;
  border-radius: 8px;
  border: 1px solid black;
  padding: 15px 10px;
  background: #282a33;
  font-size: var(--vk-fs-md);
}
.read-error {
  margin-top: 8px;
  color: #f56c6c;
  font-size: var(--vk-fs-xs);
  line-height: 16px;
}
</style>
